{#if type === 'ol_list'}
  <ol>
    <slot></slot>
  </ol>
{:elseif type === 'ul_list'}
  <ul>
    <slot></slot>
  </ul>
{:elseif type === 'list_item'}
  <li>
    <slot></slot>
  </li>
{/if}

<style>
  ol {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }
  ul {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
    list-style: disc!important;
    padding-left: 20px!important;
  }
  li {
    font-size: 1.1rem;
    line-height: 1.5;
    /*font-family: "FormularRegular";*/
  }
</style>
